import { useState } from "react";
import { useAuth } from "@/contexts/AuthContext";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import logoImg from "@/assets/logo.png";

export default function LoginPage() {
  const { login, register } = useAuth();
  const [isRegister, setIsRegister] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [name, setName] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    const result = isRegister
      ? await register(email, password, name)
      : await login(email, password);
    if (!result.success) {
      setError(result.error);
    }
    setLoading(false);
  };

  return (
    <div className="min-h-screen flex" data-testid="login-page">
      {/* Left - Image */}
      <div
        className="hidden lg:flex lg:w-1/2 relative items-center justify-center"
        style={{
          backgroundImage: "url(https://images.pexels.com/photos/7690454/pexels-photo-7690454.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940)",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div className="absolute inset-0 bg-black/70" />
        <div className="relative z-10 text-center px-12">
          <img src={logoImg} alt="FitPro" className="w-16 h-16 rounded-2xl mx-auto mb-6" />
          <h1
            className="text-5xl lg:text-6xl font-black tracking-tighter uppercase text-white mb-4"
            style={{ fontFamily: 'Barlow Condensed, sans-serif' }}
          >
            FITPRO
          </h1>
          <p className="text-lg text-zinc-300 tracking-wide" style={{ fontFamily: 'Manrope, sans-serif' }}>
            Gestisci i percorsi dei tuoi clienti come un professionista
          </p>
        </div>
      </div>

      {/* Right - Form */}
      <div className="flex-1 flex items-center justify-center bg-[#0A0A0A] px-6">
        <div className="w-full max-w-md">
          {/* Mobile logo */}
          <div className="lg:hidden flex items-center gap-3 mb-8 justify-center">
            <img src={logoImg} alt="FitPro" className="w-10 h-10 rounded-xl" />
            <span
              className="text-3xl font-black tracking-tighter uppercase text-white"
              style={{ fontFamily: 'Barlow Condensed, sans-serif' }}
            >
              FITPRO
            </span>
          </div>

          <h2
            className="text-2xl sm:text-3xl font-bold tracking-tight uppercase text-white mb-2"
            style={{ fontFamily: 'Barlow Condensed, sans-serif' }}
          >
            {isRegister ? "CREA ACCOUNT" : "ACCEDI"}
          </h2>
          <p className="text-zinc-500 text-sm mb-8" style={{ fontFamily: 'Manrope, sans-serif' }}>
            {isRegister ? "Registrati per iniziare" : "Inserisci le tue credenziali"}
          </p>

          <form onSubmit={handleSubmit} className="space-y-5" data-testid="login-form">
            {isRegister && (
              <div>
                <Label className="text-zinc-400 text-xs font-bold uppercase tracking-[0.15em]">Nome</Label>
                <Input
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  placeholder="Il tuo nome"
                  className="mt-1.5 bg-[#0A0A0A] border-[#262626] focus:border-[#007AFF] text-white placeholder:text-zinc-600"
                  required
                  data-testid="register-name-input"
                />
              </div>
            )}

            <div>
              <Label className="text-zinc-400 text-xs font-bold uppercase tracking-[0.15em]">Email</Label>
              <Input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="nome@email.com"
                className="mt-1.5 bg-[#0A0A0A] border-[#262626] focus:border-[#007AFF] text-white placeholder:text-zinc-600"
                required
                data-testid="login-email-input"
              />
            </div>

            <div>
              <Label className="text-zinc-400 text-xs font-bold uppercase tracking-[0.15em]">Password</Label>
              <Input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="La tua password"
                className="mt-1.5 bg-[#0A0A0A] border-[#262626] focus:border-[#007AFF] text-white placeholder:text-zinc-600"
                required
                data-testid="login-password-input"
              />
            </div>

            {error && (
              <div className="text-red-400 text-sm bg-red-500/10 border border-red-500/20 rounded-md px-3 py-2" data-testid="login-error">
                {error}
              </div>
            )}

            <Button
              type="submit"
              disabled={loading}
              className="w-full bg-[#007AFF] hover:bg-[#3395FF] text-white font-semibold h-11"
              data-testid="login-submit-button"
            >
              {loading ? "Caricamento..." : isRegister ? "Registrati" : "Accedi"}
            </Button>
          </form>

          <p className="text-center text-zinc-500 text-sm mt-6">
            {isRegister ? "Hai già un account?" : "Non hai un account?"}{" "}
            <button
              onClick={() => { setIsRegister(!isRegister); setError(""); }}
              className="text-[#007AFF] hover:text-[#3395FF] font-medium transition-colors"
              data-testid="toggle-auth-mode"
            >
              {isRegister ? "Accedi" : "Registrati"}
            </button>
          </p>
        </div>
      </div>
    </div>
  );
}
